import { camelize } from 'humps'

export interface IVerificationKeys {
  notVerified: string
  covered: string
  excluded: string
}

export const verifications = [
  { label: 'Not Verified', value: 'not_verified' },
  { label: 'Covered', value: 'covered' },
  { label: 'Excluded', value: 'excluded' },
]

export const VERIFICATION_KEYS = verifications.reduce(
  (acc, v) => Object.assign(acc, { [camelize(v.value)]: v.value }),
  {}
)
